import { Card, CardContent } from "@/components/ui/card";
import { ClientsAttendedData, DashboardFilters } from "@/types/dashboard";
import { Users } from "lucide-react";

interface ClientsAttendedCardProps {
  data: ClientsAttendedData;
  period?: DashboardFilters["period"];
}

const periodLabels: Record<string, string> = {
  today: "Hoje",
  yesterday: "Ontem",
  week: "Semana",
  month: "Mês",
  custom: "Período",
};

export function ClientsAttendedCard({ data, period = "today" }: ClientsAttendedCardProps) {
  const periodLabel = periodLabels[period || "today"] || "Hoje";

  return (
    <Card className="h-full border-0 shadow-lg bg-gradient-to-br from-cyan-400 via-cyan-500 to-teal-600 text-white">
      <CardContent className="p-5">
        <div className="flex items-center gap-2 mb-4">
          <div className="p-2 bg-white/20 backdrop-blur rounded-lg">
            <Users className="h-4 w-4" />
          </div>
          <span className="font-medium">Clientes Atendidos</span>
        </div>

        <p className="text-3xl font-bold mb-1">{data.today}</p>
        <p className="text-cyan-200 text-sm">{periodLabel}</p>

        <div className="mt-4 pt-3 border-t border-white/20">
          <div className="flex items-center justify-between">
            <span className="text-cyan-200 text-sm">Total no mês</span>
            <span className="font-semibold">{data.month} clientes</span>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}
